/*eslint no-script-url: 0 */
import React, { Component } from 'react';
//import Constants from '../../Config/Config';
import {Loader} from '../../Helpers/Helpers';
import classNames from 'classnames';

var q, v = Math.PI / 180;

var canvas;
var context;

var dstImage;
var dstCtxImage;

var dstFrame;
var dstFrameCtx;

var dstMat;
var dstMatCtx;

var dstFrameImage;
var dstFrameCtxImage;

var ia1, ja1, ka, la, ma, na;

export default class FrameImageWork extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	frameIsLoading: false
	    }
  	}

	componentDidUpdate(prevProps, prevState) {
        if ( prevProps.selectedTopMat !== this.props.selectedTopMat || prevProps.selectedMiddleMat !== this.props.selectedMiddleMat || prevProps.selectedBottomMat !== this.props.selectedBottomMat || prevProps.selectedTopMatValueInCM !== this.props.selectedTopMatValueInCM || prevProps.selectedMiddleMatValueInCM !== this.props.selectedMiddleMatValueInCM || prevProps.selectedBottomMatValueInCM !== this.props.selectedBottomMatValueInCM || prevProps.selectedMatSize !== this.props.selectedMatSize || prevProps.selectedFrame !== this.props.selectedFrame || prevProps.frameImageHeight !== this.props.frameImageHeight || prevProps.frameImageWidth !== this.props.frameImageWidth ) {
            this.drawFrame()
        }
        if ( prevProps.frameImage !== this.props.frameImage && this.props.frameImage !== null ) {
        	this.drawImage()
        }
    }

	componentDidMount() {
		this.prepareCanvas()
		if (this.props.frameImage !== null) {
			this.drawImage()
		}
	}

	prepareCanvas() {
		canvas = document.getElementById('framepreview');
		context = canvas.getContext("2d");

		let {frameImageHeight, frameImageWidth} = this.props;

		if (parseFloat(frameImageHeight) <= 0)
			frameImageHeight = 20
		if (parseFloat(frameImageWidth) <= 0)
			frameImageWidth = 20

		var self = this;
		q = Math.min(1e3 / frameImageWidth, 1e3 / frameImageHeight);

		canvas.width = frameImageWidth * q;
		canvas.height = frameImageHeight * q;

		dstImage = document.createElement('canvas');
		dstCtxImage = dstImage.getContext('2d');

		dstCtxImage.fillStyle = '#fff';
		dstCtxImage.fillRect(0, 0, canvas.width, canvas.height);
		dstCtxImage.save();

		dstCtxImage.save();
		dstCtxImage.shadowBlur = 20;
		dstCtxImage.shadowOffsetX = 0;
		dstCtxImage.shadowOffsetY = 0;
		dstCtxImage.shadowColor = 'rgba(68,68,68,0.5)';
		dstCtxImage.lineWidth = 15;
		var ja = dstCtxImage.lineWidth / 2;
		dstCtxImage.strokeRect(0 - ja, 0 - ja, canvas.width + 2 * ja, canvas.height + 2 * ja);
		dstCtxImage.restore();

		self.drawFrame();
	}

	drawImage() {
		const {frameImage} = this.props;
		let {frameImageHeight, frameImageWidth} = this.props;
		q = Math.min(1e3 / frameImageWidth, 1e3 / frameImageHeight);
		var self = this;

		dstFrameImage = document.createElement('canvas');
		dstFrameCtxImage = dstFrameImage.getContext('2d');

		// Load images
		// -----------
		var frameImageO = new Image();
		frameImageO.src = frameImage;
		frameImageO.setAttribute('crossOrigin', 'anonymous');
		frameImageO.onload = function() {
			dstFrameImage.width = frameImageO.width;
			dstFrameImage.height = frameImageO.height;
			dstFrameCtxImage.drawImage(frameImageO, 0, 0);
			self.drawFrame()
		};
	}

	drawFrame() {
		this.checkSizes()
		this.setState({frameIsLoading: true});

		const {selectedFrame, selectedMatSize, selectedTopMat, selectedMiddleMat, selectedBottomMat, selectedTopMatValueInCM, selectedMiddleMatValueInCM, selectedBottomMatValueInCM} = this.props;
		let {frameImageHeight, frameImageWidth} = this.props;

		if (parseFloat(frameImageHeight) <= 0)
			frameImageHeight = 20
		if (parseFloat(frameImageWidth) <= 0)
			frameImageWidth = 20

		var self = this;
		q = Math.min(1e3 / frameImageWidth, 1e3 / frameImageHeight);

		canvas.width = frameImageWidth * q;
		canvas.height = frameImageHeight * q;

		/* console.log('Width: '+ canvas.width)
		console.log('Height: '+ canvas.height)*/

		var frameSImage = new Image();
		frameSImage.src = this.props.selectedFrame.get('square_image');
		frameSImage.setAttribute('crossOrigin', 'anonymous');
		frameSImage.onload = function() {
			var matia1 = 0
			var matja1 = 0

			if ( parseFloat(selectedMatSize) !== 0 ) {
				var matWidth = 0;
				var multi = 0;

				if ( parseFloat(selectedMatSize) === 1 ) {
					matWidth = parseFloat(selectedTopMatValueInCM)
				} else if ( parseFloat(selectedMatSize) === 2 ) {
					matWidth = parseFloat(selectedTopMatValueInCM) + parseFloat(selectedMiddleMatValueInCM)
				} else if ( parseFloat(selectedMatSize) === 3 ) {
					matWidth = parseFloat(selectedTopMatValueInCM) + parseFloat(selectedMiddleMatValueInCM) + parseFloat(selectedBottomMatValueInCM)
				}

				matia1 = parseFloat(matWidth) * q
				matja1 = parseFloat(matWidth) * q
				var matka = parseFloat(matWidth) * q
				var matla = parseFloat(matWidth) * q
				var matma = parseFloat(canvas.width) + matia1 + matja1
				var matna = parseFloat(canvas.height) + matka + matla

				dstMat = document.createElement('canvas');
				dstMat.width = matma;
				dstMat.height = matna;
				dstMatCtx = dstMat.getContext('2d');

				canvas.width = dstMat.width;
				canvas.height = dstMat.height;

				if ( parseFloat(selectedMatSize) === 1 ) {
					dstMatCtx.fillStyle = selectedTopMat.getIn(['acf', 'color'])
					dstMatCtx.fillRect(0, 0, dstMat.width, dstMat.height);

					// Border
					dstMatCtx.strokeStyle = "#D3D3D3";
				    dstMatCtx.lineWidth   = 10;
				    dstMatCtx.strokeRect(matia1, matia1, dstMat.width - (matia1 * 2), dstMat.height - (matia1 * 2));
    			} else if ( parseFloat(selectedMatSize) === 2 ) {
  					// Top Mat
					dstMatCtx.fillStyle = selectedTopMat.getIn(['acf', 'color'])
					dstMatCtx.fillRect(0, 0, dstMat.width, dstMat.height);

					// Border
					multi = (parseFloat(selectedTopMatValueInCM) * q) * 2
					dstMatCtx.strokeStyle = "#D3D3D3";
				    dstMatCtx.lineWidth   = 10;
				    dstMatCtx.strokeRect(parseFloat(selectedTopMatValueInCM) * q, parseFloat(selectedTopMatValueInCM) * q, dstMat.width - multi, dstMat.height - multi);

					// Middle Mat
					dstMatCtx.fillStyle = selectedMiddleMat.getIn(['acf', 'color'])
					dstMatCtx.fillRect( parseFloat(selectedTopMatValueInCM) * q, parseFloat(selectedTopMatValueInCM) * q, dstMat.width - ((parseFloat(selectedTopMatValueInCM) * q) * 2), dstMat.height - ((parseFloat(selectedTopMatValueInCM) * q) * 2));

					// Border
					dstMatCtx.strokeStyle = "#D3D3D3";
				    dstMatCtx.lineWidth   = 10;
				    dstMatCtx.strokeRect( matia1, matia1, dstMat.width - (matia1 * 2), dstMat.height - (matia1 * 2));
				} else if ( parseFloat(selectedMatSize) === 3 ) {
					// Top Mat
					dstMatCtx.fillStyle = selectedTopMat.getIn(['acf', 'color'])
					dstMatCtx.fillRect(0, 0, dstMat.width, dstMat.height);

					// Border
					multi = (parseFloat(selectedTopMatValueInCM) * q) * 2
					dstMatCtx.strokeStyle = "#D3D3D3";
				    dstMatCtx.lineWidth   = 10;
				    dstMatCtx.strokeRect(parseFloat(selectedTopMatValueInCM) * q, parseFloat(selectedTopMatValueInCM) * q, dstMat.width - multi, dstMat.height - multi);

					// Middle Mat
					dstMatCtx.fillStyle = selectedMiddleMat.getIn(['acf', 'color'])
					dstMatCtx.fillRect(parseFloat(selectedTopMatValueInCM) * q, parseFloat(selectedTopMatValueInCM) * q, dstMat.width - ((parseFloat(selectedTopMatValueInCM) * q) * 2), dstMat.height - ((parseFloat(selectedTopMatValueInCM) * q) * 2));

					// Border
					multi = (parseFloat(selectedTopMatValueInCM) * q) + (parseFloat(selectedMiddleMatValueInCM) * q)
					dstMatCtx.strokeStyle = "#D3D3D3";
				    dstMatCtx.lineWidth   = 10;
				    dstMatCtx.strokeRect( multi, multi, dstMat.width - (multi * 2), dstMat.height - (multi * 2));

					// Bottom Mat
					var teen = (parseFloat(selectedTopMatValueInCM) * q) + (parseFloat(selectedMiddleMatValueInCM) * q);
					dstMatCtx.fillStyle = selectedBottomMat.getIn(['acf', 'color'])
					dstMatCtx.fillRect(teen, teen, dstMat.width - (teen * 2), dstMat.height - (teen * 2));

					// Border
					dstMatCtx.strokeStyle = "#D3D3D3";
				    dstMatCtx.lineWidth   = 10;
				    dstMatCtx.strokeRect( matia1, matia1, dstMat.width - (matia1 * 2), dstMat.height - (matia1 * 2));
				}
			}

			var typeWidth = selectedFrame.getIn(['dimensions', 'width']);

			ia1 = parseFloat(typeWidth) * q
			ja1 = parseFloat(typeWidth) * q
			ka = parseFloat(typeWidth) * q
			la = parseFloat(typeWidth) * q
			ma = parseFloat(canvas.width) + ia1 + ja1
			na = parseFloat(canvas.height) + ka + la

			dstFrame = document.createElement('canvas');
			dstFrame.width = ma;
			dstFrame.height = na;
			dstFrameCtx = dstFrame.getContext('2d');

			canvas.width = dstFrame.width;
			canvas.height = dstFrame.height;

			var ra = frameSImage.height
			var sa = parseFloat((q * typeWidth / ra).toFixed(2))
			var ta = parseInt(dstFrame.width / sa, 10)
			var ua = parseInt(dstFrame.height / sa, 10)

			dstFrameCtx.fillStyle = dstFrameCtx.createPattern(frameSImage, 'repeat-x')
			dstFrameCtx.save()
			dstFrameCtx.scale(sa, sa)
			dstFrameCtx.fillRect(0, 0, ta, frameSImage.height)
			dstFrameCtx.restore()
			dstFrameCtx.save()
			dstFrameCtx.scale(sa, sa)
			dstFrameCtx.beginPath()
			dstFrameCtx.translate(ta, ua)
			dstFrameCtx.rotate(180 * v)
			dstFrameCtx.moveTo(0, 0)
			dstFrameCtx.fillRect(0, 0, ta, frameSImage.height)
			dstFrameCtx.rotate(180 * v)
			dstFrameCtx.restore()
			dstFrameCtx.save()
			dstFrameCtx.scale(sa, sa)
			dstFrameCtx.translate(0, ua)
			dstFrameCtx.rotate( - 90 * v)
			dstFrameCtx.beginPath()
			dstFrameCtx.moveTo(0, 0)
			dstFrameCtx.lineTo(frameSImage.height, frameSImage.height)
			dstFrameCtx.lineTo(ua - frameSImage.height, frameSImage.height)
			dstFrameCtx.lineTo(ua, 0)
			dstFrameCtx.lineTo(0, 0)
			dstFrameCtx.closePath()
			dstFrameCtx.clip()
			dstFrameCtx.fill()
			dstFrameCtx.rotate(90 * v)
			dstFrameCtx.translate(0, -ua)
			dstFrameCtx.restore()
			dstFrameCtx.save()
			dstFrameCtx.scale(sa, sa)
			dstFrameCtx.translate(ta, 0)
			dstFrameCtx.rotate(90 * v)
			dstFrameCtx.beginPath()
			dstFrameCtx.moveTo(0, 0)
			dstFrameCtx.lineTo(frameSImage.height, frameSImage.height)
			dstFrameCtx.lineTo(ua - frameSImage.height, frameSImage.height)
			dstFrameCtx.lineTo(ua, 0)
			dstFrameCtx.lineTo(0, 0)
			dstFrameCtx.closePath()
			dstFrameCtx.clip()
			dstFrameCtx.fill()
			dstFrameCtx.rotate( - 90 * v)
			dstFrameCtx.translate( - ta, 0)
			dstFrameCtx.restore()

			// Frame corners
			context.drawImage(dstFrame, 0, 0, dstFrame.width, dstFrame.height, 0, 0, canvas.width, canvas.height);

			// Mats
			if ( parseFloat(selectedMatSize) !== 0 ) {
				context.drawImage(dstMat, 0, 0, dstMat.width, dstMat.height, ia1, ia1, canvas.width - (ia1 + ia1),canvas.height - (ia1 + ia1));
			}

			// Main Image
			if (self.props.frameImage !== null) {
				context.drawImage(dstFrameImage, 0, 0, dstFrameImage.width, dstFrameImage.height, ia1 + matia1, ia1 + matia1, canvas.width - (ia1 + ja1 + matia1 + matja1), canvas.height - (ia1 + ja1 + matia1 + matja1));
			} else {
				context.drawImage(dstImage, 0, 0, dstImage.width, dstImage.height, ia1 + matia1, ia1 + matia1, canvas.width - (ia1 + ja1 + matia1 + matja1), canvas.height - (ia1 + ja1 + matia1 + matja1));
			}

			self.props.dispatch({
				type: 'SET_STATE',
				state: {
					canvasImage: canvas.toDataURL()
				}
	    	})
	    	self.generateThumb();
		};
	}

	generateThumb() {
		var self = this;
		var thumbSize = 250;
		var canvasThumb = document.getElementById("framepreview");

		var thumbDim = Math.min(thumbSize / canvasThumb.width, thumbSize / canvasThumb.height)

		var canvasThumbEle = document.createElement('canvas');
		canvasThumbEle.width = Math.floor(canvasThumb.width * thumbDim);
		canvasThumbEle.height = Math.floor(canvasThumb.height * thumbDim);
		var thumbContext = canvasThumbEle.getContext("2d");

		var imgCanvas = new Image();
		imgCanvas.onload = function(e) {
			thumbContext.fillStyle = '#FFFFFF'
			thumbContext.fillRect(0, 0, canvasThumbEle.width, canvasThumbEle.height)
			thumbContext.scale(thumbDim, thumbDim)
		    thumbContext.drawImage(canvasThumb, 0, 0);
			self.props.dispatch({
				type: 'SET_STATE',
				state: {
					canvasThumbImage: canvasThumbEle.toDataURL()
				}
			})
			self.setState({frameIsLoading: false});
		};
		imgCanvas.src = this.props.canvasImage;
	}

	checkSizes() {
		const {frameImageHeight, frameImageWidth} = this.props;

		// Images size
		if(frameImageWidth < 20 || frameImageWidth > 125 || frameImageHeight < 20 || frameImageHeight > 125 ) {
	        this.props.dispatch({
	            type: 'SET_STATE',
	            state: {
	                imageSizeError: true
	            }
	        });
		} else {
	        this.props.dispatch({
	            type: 'SET_STATE',
	            state: {
	                imageSizeError: false
	            }
	        });
		}
	}

	render() {
		const loaderClass = classNames('', {'hidden': this.state.frameIsLoading || this.props.libraryImageUploading});
		return (
			<div className="canvas-image">
				{(this.state.frameIsLoading || this.props.libraryImageUploading) &&
					<Loader />
				}
				<canvas id="framepreview" className={loaderClass} style={{maxHeight: this.props.rightFrameHeight - 4 +'px'}}></canvas>
			</div>
	    );
	}
}